export { default } from './SellerPageHeader';